import React from 'react';

const MyCounter = () => {

    // console.log('document.location: ', document.location);
    // console.log('document.referrer: ', document.referrer);
    // // console.log('location.referrer: ', location.referrer);
    // console.log('document.location.referrer: ', document.location.referrer);
    // console.log('window.location: ', window.location);
    // console.log('window.location.referrer: ', window.location.referrer);
    // console.log('document.location.href: ', document.location.href);

    return (
        <>
            <img src={ 'https://massaclub.com/stat/?id=10&ref=' + document.referrer + '&current=' + document.location.href } alt=""/>
            {/* <img src={ 'https://massaclub.com/stat2/?ref=' + document.referrer } alt=""/> */}
        </>
    )
}

export default MyCounter